import { render, staticRenderFns } from "./Homepage.vue?vue&type=template&id=24b9f7b6"
import script from "./Homepage.vue?vue&type=script&lang=ts"
export * from "./Homepage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports